import script from "./OtterWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./OtterWidget.vue?vue&type=script&setup=true&lang=js"

import "./OtterWidget.vue?vue&type=style&index=0&id=1c5448e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5448e9"]])

export default __exports__